import { render, staticRenderFns } from "./page_loader.vue?vue&type=template&id=119cb298"
import script from "./page_loader.vue?vue&type=script&lang=js"
export * from "./page_loader.vue?vue&type=script&lang=js"
import style0 from "./page_loader.vue?vue&type=style&index=0&id=119cb298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports